import { Auth } from "aws-amplify";
import axios from "axios";
import Spinner from "react-bootstrap/Spinner";
import { useEffect, useState } from "react";

import { Button } from "..";
import styles from "./styles.module.css";

const serverUrl = process.env.REACT_APP_SERVER_URL;

const getToken = async () => {
  const data = await Auth.currentSession();
  return data.idToken.jwtToken;
};

export const Membership = () => {
  const [settings, setSettings] = useState({
    monthly_unlock_limit: 0,
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const [saveError, setSaveError] = useState(null);

  useEffect(() => {
    const fetchSettings = async () => {
      setLoading(true);
      try {
        const token = await getToken();
        const response = await axios.get(serverUrl + "admin/membership/settings", {
          headers: { "X-Hemingway-Authorization": "Bearer " + token },
        });
        setSettings({
          monthly_unlock_limit: response.data.monthly_unlock_limit || 0,
        });
      } catch (error) {
        console.error("Error fetching membership settings:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const handleSave = async () => {
    setSaving(true);
    setSaveSuccess(false);
    setSaveError(null);
    try {
      const token = await getToken();
      await axios.post(serverUrl + "admin/membership/settings", settings, {
        headers: { "X-Hemingway-Authorization": "Bearer " + token },
      });
      setSaveSuccess(true);
      setTimeout(() => setSaveSuccess(false), 3000);
    } catch (error) {
      console.error("Error saving membership settings:", error);
      setSaveError("Failed to save. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <Spinner />
      </div>
    );
  }

  return (
    <div>
      <div className={styles.header}>
        <h3>Membership Settings</h3>
      </div>

      <div className={styles.section}>
        <h5 className={styles.sectionTitle}>Membership Types</h5>
        <p className={styles.description}>
          <strong>Full Member</strong> — Unrestricted door access. Has a locker.
          <br />
          <strong>Limited Member</strong> — Door access is capped at X visits per month (configured below). No locker.
          <br />
          <strong>Guest Member</strong> — Out-of-town day pass. Access is restricted to purchased date(s) between 7:00 AM and 10:00 PM. Set dates per guest from the Users tab. No locker.
        </p>
      </div>

      <div className={styles.section}>
        <h5 className={styles.sectionTitle}>Limited Member — Monthly Access Limit</h5>
        <p className={styles.hint}>
          The maximum number of times a Limited Member can open the door per calendar month. Set to 0 for no limit.
        </p>

        <div className={styles.field}>
          <label className={styles.label}>Monthly Unlock Limit</label>
          <input
            type="number"
            min="0"
            value={settings.monthly_unlock_limit}
            onChange={(e) =>
              setSettings((prev) => ({
                ...prev,
                monthly_unlock_limit: parseInt(e.target.value, 10) || 0,
              }))
            }
            className={styles.numberInput}
          />
          {settings.monthly_unlock_limit === 0 && (
            <span className={styles.hint}>0 = no limit.</span>
          )}
        </div>
      </div>

      <div className={styles.saveRow}>
        {saveError && <span className={styles.error}>{saveError}</span>}
        {saveSuccess && <span className={styles.success}>Settings saved!</span>}
        <Button
          style={{ width: "160px", height: "40px", marginTop: 0 }}
          onClick={handleSave}
          disabled={saving}
        >
          {saving ? <Spinner style={{ marginTop: "3px" }} /> : "Save Settings"}
        </Button>
      </div>
    </div>
  );
};
